//
import React, { useEffect, useState } from "react";
import moment from "moment";
//component
import TriggerInit from "./trigger/trigger_init";
import { Input } from "antd";
import { CloseOutlined, EditOutlined, SaveOutlined } from "@ant-design/icons";
import { App, Button, Col, Row, Space, Tooltip } from "antd";
import { FaPause, FaPlay } from "react-icons/fa6";
//redux
//selector
import {
  draftDialogDetailSelector,
  draftDialogPlaySelector,
  draftDialogSecondSelector,
} from "store/bailiff/draft/dialog/draft_dialog.selector";
//actions
import {
  setDraftDialogEditCard,
  setDraftDialogKick,
  setDraftDialogPlay,
} from "store/bailiff/draft/dialog/draft_dialog.action";
//utils
import { refineSpecificTimer } from "util/refine_timer.function";
//hook
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useDialogQCClone } from "hook/draft/dialog/useDialogsQCClone";
//str

const { TextArea } = Input;
const CardDraftSegmentClone = ({ data }) => {
  // -------------------------- VAR -----------------------------
  const { loading, handleUpdateSegment } = useDialogQCClone();
  const { message } = App?.useApp();
  const speaker = data?.fixSpeaker || data.speaker;
  const text = data?.fix || data?.text;
  const start = data?.fixStart || data?.start;
  const end = data?.fixEnd || data?.end;
  const slot = data?.slot;
  const labelStart = refineSpecificTimer({ timer: start });
  const labelEnd = refineSpecificTimer({ timer: end });
  const duration = `${labelStart} - ${labelEnd}`;
  // -------------------------- STATE ---------------------------
  const [edit, setEdit] = useState(false);
  const [content, setContent] = useState("");
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const dialog = useSelector(draftDialogDetailSelector);
  const second = useSelector(draftDialogSecondSelector);
  const play = useSelector(draftDialogPlaySelector);
  const isPlaySecond = second >= start && second <= end;
  const isPlay = isPlaySecond && play;
  const rated = dialog?.rated || false;

  // -------------------------- FUNCTION ------------------------
  const togglePlay = () => {
    if (start === null) return message.error("Dữ liệu không tìm thấy!");
    const id = `change-${moment()?.valueOf()}-${start}`;
    dispatch(setDraftDialogPlay(!play));
    dispatch(setDraftDialogKick(id));
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setContent(value);
  };

  const handleSave = () => {
    const segment = { slot, content, start, end, speaker, setEdit };
    console.log(segment);

    return handleUpdateSegment(segment);
  };
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    dispatch(setDraftDialogEditCard(edit));
  }, [edit, dispatch]);
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderSpeaker = () => {
    return <b style={{ fontSize: 16 }}>Người nói: {speaker}</b>;
  };

  const renderEdit = () => {
    if (edit) return null;
    return (
      <Tooltip title="Chỉnh sửa đoạn hội thoại">
        <Button
          onClick={() => setEdit(true)}
          shape="circle"
          type="text"
          icon={<EditOutlined />}
        />
      </Tooltip>
    );
  };

  const renderSave = () => {
    if (!edit) return null;
    return (
      <Space>
        <Tooltip title="Huỷ chỉnh sửa">
          <Button
            loading={loading}
            onClick={() => setEdit(false)}
            shape="circle"
            type="text"
            icon={<CloseOutlined />}
            danger
          />
        </Tooltip>
        <Tooltip title="Lưu lại đoạn hội thoại">
          <Button
            loading={loading}
            onClick={handleSave}
            shape="circle"
            type="text"
            icon={<SaveOutlined />}
          />
        </Tooltip>
      </Space>
    );
  };

  const renderPlay = () => {
    return (
      <Tooltip title="Nghe lại đoạn hội thoại">
        <Button
          onClick={togglePlay}
          shape="circle"
          type="text"
          icon={
            <span className="anticon">
              {!isPlay ? <FaPlay /> : <FaPause />}
            </span>
          }
        />
      </Tooltip>
    );
  };

  const renderAction = () => {
    return (
      <Space>
        {renderEdit()}
        {renderSave()}
        {renderPlay()}
      </Space>
    );
  };

  const renderTextArea = () => {
    if (!edit) return <p>{content}</p>;
    return (
      <TextArea
        onChange={handleChange}
        placeholder="Chỉnh sửa hội thoại"
        defaultValue={content}
        rows={4}
      />
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <Row
      style={{
        display: "flex",
        alignItems: "center",
        borderTop: "0.5px solid rgba(0,0,0,0.1)",
        paddingTop: 10,
      }}
    >
      <Col xl={12} lg={12} md={12} xs={12}>
        {renderSpeaker()}
      </Col>
      <Col align="right" xl={12} lg={12} md={12} xs={12}>
        {renderAction()}
      </Col>
      <Col xl={24} lg={24} md={24} xs={24}>
        <span style={{ color: "#aeaeae" }}>{duration}</span>
      </Col>
      <Col xl={24} lg={24} md={24} xs={24}>
        {renderTextArea()}
      </Col>
      <TriggerInit text={text} setContent={setContent} />
    </Row>
  );
};
export default CardDraftSegmentClone;
